<div @fadeSlide class="py-2 bg-white" *ngIf="isOutOfView">
  <div class="container d-flex flex-row gap-2 align-items-center">
    <img
      *ngIf="product.images[0]"
      height="64"
      width="64"
      sizes="10"
      [ngSrc]="product.images[0].src"
      [loaderParams]="{ aspect: 1 }"
    />
    <div class="titles">
      <div class="eyebrow" *ngIf="product.title.split(' | ').length > 3">
        {{
          product.title.includes(" | ")
            ? product.title.split(" | ")[3] +
              " " +
              (product.title.split(" | ")[4] ?? "")
            : product.title
        }}
      </div>
      <div class="d-flex flex-column flex-lg-row align-items-start">
        <h1 class="lh-1 h2 me-3">
          {{ product.title | titleExtractor }}
        </h1>
      </div>
    </div>
    <div class="ms-auto">
      <button (click)="scrollTo()" class="btn btn-dark px-3">
        Explore Options
      </button>
    </div>
  </div>
</div>
